import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { loadLocationsWithinRadius } from "../../../_redux/actions/appointmentActions";
import { RingLoader, GoogleMaps } from "@/_components";
import { utilities, langConversionHelper } from "@/_helpers";
import { Australia, USA } from "../../../_helpers/CountryConstants";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StoreIcon from "@mui/icons-material/Store";
import CallIcon from "@mui/icons-material/Call";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";

import {
  LifeSafer,
  Monitech,
  Guardian,
  QuickStart,
} from "../../../_helpers/BrandConstants";
import { brandColors } from "../../../_components/brandedComponent/BrandedColors";
import LogoLimitedSameDay from "../../../_images/samedayicons/LS_SameDayIconAlt.png";
import GuardianSameDay from "../../../_images/samedayicons/Guard_SameDayAlt.png";
import MonitechSameDay from "../../../_images/samedayicons/Mon_SameDayAlt.png";
import QuickStartSameDay from "../../../_images/samedayicons/QS_SameDayAlt.png";
import VanIcon from "../../../_images/vanicons/VanIcon.png";
import SameDayVanIcon from "../../../_images/vanicons/SameDayVanIcon.png";
import QS_VanIcon from "../../../_images/vanicons/QS_VanIcon.png";
import QS_SameDayVanIcon from "../../../_images/vanicons/QS_SameDayVanIcon.png";
import Mon_VanIcon from "../../../_images/vanicons/Mon_VanIcon.png";
import Mon_SameDayVanIcon from "../../../_images/vanicons/Mon_SameDayVanIcon.png";
import Guard_VanIcon from "../../../_images/vanicons/Guard_VanIcon.png";
import Guard_SameDayVanIcon from "../../../_images/vanicons/Guard_SameDayVanIcon.png";
import TextField from '@mui/material/TextField';

const navOptions = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};

function AppointmentLocation({
  locations,
  loadLocationsWithinRadius,
  selectedLocation,
  prefillDeviceType,
  isLoaded,
}) {
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const siteCountry = cookies.get("siteCountry") || USA;
  const enrolleeUser = cookies.get("lifesaferEnrollment");
  const enrolleeUserData = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const enrollNow = cookies.get("EnrollNow") || {};
  const partnerList = enrolleeUser?.locationIds?.split(",");
  const { t, i18n } = useTranslation();
  const [getMap, setGetMap] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [searching, setSearching] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const isMountedRef = useRef(null);
  const [defaultCenter, setDefaultCenter] = useState({ lat: 0, lng: 0 });
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(enrolleeUserData?.zip || null);

  const StyledIconButton = styled(IconButton)(() => ({
    padding: 10,
  }));

  const StyledDivider = styled(Divider)(() => ({
    height: 32,
    margin: "4px 2px",
  }));

  const CardHeader = styled(Grid, {
    shouldForwardProp: (prop) => prop !== "brand",
  })(({ brand }) => ({
    backgroundColor: brandColors[brand].primary,
    color: "#fff",
    paddingLeft: 20,
    minHeight: 36,
    maxHeight: 48,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  }));

  // const HeaderStyling = styled(Grid, {
  //   shouldForwardProp: (prop) => prop !== "brand",
  // })(() => ({
  //   backgroundColor: "#BBBBBB",
  //   color: "#707070",
  //   fontSize: 16,
  //   marginTop: 8,
  //   padding: "8px 16px",
  //   textAlign: "center",
  //   fontWeight: "bold",
  // }));

  const LocationsHolder = styled(Grid)(() => ({
    // height: 419,
    maxHeight:419,
    overflowY: "auto",
    overflowX: "hidden",
    gap: "7px",
  }));

  const CustomIcon = styled(StoreIcon, {
    shouldForwardProp: (prop) => prop !== "brand",
  })(({ brand }) => ({
    color: brandColors[brand].primary,
    height: 200,
    width: 200,
    opacity: 0.1,
  }));

  const CustomTypo = styled(Typography)(() => ({
    textAlign: "center",
    zIndex: 10,
    fontSize: 20,
    marginTop: -130,
    marginBottom: 130,
  }));

  const CallButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== "brand",
  })(({ brand }) => ({
    backgroundColor: brandColors[brand].primary,
    color: "white",
    "&:hover": {
      backgroundColor: brandColors[brand].secondary,
    },
  }));

  //default to LS
  let sameDayIconAltUrl = LogoLimitedSameDay;
  if (brand === LifeSafer) {
    sameDayIconAltUrl = LogoLimitedSameDay;
  } else if (brand === Guardian) {
    sameDayIconAltUrl = GuardianSameDay;
  } else if (brand === Monitech) {
    sameDayIconAltUrl = MonitechSameDay;
  } else if (brand === QuickStart) {
    sameDayIconAltUrl = QuickStartSameDay;
  }

  let sameDayVanIconAltUrl = SameDayVanIcon;
  if (brand === LifeSafer) {
    sameDayVanIconAltUrl = SameDayVanIcon;
  } else if (brand === Guardian) {
    sameDayVanIconAltUrl = Guard_SameDayVanIcon;
  } else if (brand === Monitech) {
    sameDayVanIconAltUrl = Mon_SameDayVanIcon;
  } else if (brand === QuickStart) {
    sameDayVanIconAltUrl = QS_SameDayVanIcon;
  }

  let vanIconAltUrl = VanIcon;
  if (brand === LifeSafer) {
    vanIconAltUrl = VanIcon;
  } else if (brand === Guardian) {
    vanIconAltUrl = Guard_VanIcon;
  } else if (brand === Monitech) {
    vanIconAltUrl = Mon_VanIcon;
  } else if (brand === QuickStart) {
    vanIconAltUrl = QS_VanIcon;
  }

  const getUserLocation = async () => {
    // Get Lat/Lng from user's device
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, navOptions);
    });
  };

  const getLocation = async (address) => {
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      console.error("Google Maps API not loaded");
      return [];
    }
    let geocoder = new window.google.maps.Geocoder();
    try {
      const response = await geocoder.geocode({
        address: address || "USA",
      });
      return response;
    } catch (error) {
      console.error("Error in geocode request:", error);
      return [];
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current) {
      if (enrolleeUserData !== undefined) {
        const lat = enrolleeUserData?.homeLat;
        const lng = enrolleeUserData?.homeLong;

        const homeMarker = {
          key: "Home",
          lat,
          lng,
          isHome: true,
          title: enrolleeUserData?.homeAddr1,
          label: "",
        };

        setMarkers((prev) => {
          const withoutHome = prev.filter((m) => m.key !== "Home");
          return [...withoutHome, homeMarker];
        });
      }
    }
    return () => (isMountedRef.current = false);
  }, [getMap, locations]);

  useEffect(() => {
    if (isMountedRef.current) {
      // Set Variables
      let lat = 0;
      let lng = 0;
      setDefaultCenter({ lat: lat, lng: lng });
      setLoading(true);
      // 0. Home lat/lng from userData if available
      if (
        enrolleeUserData &&
        enrolleeUserData?.homeLat &&
        enrolleeUserData?.homeLong
      ) {
        lat = enrolleeUserData?.homeLat;
        lng = enrolleeUserData?.homeLong;

        setDefaultCenter({ lat, lng });

        loadLocationsWithinRadius(
          lat,
          lng,
          300,
          prefillDeviceType,
          enrollNow?.IsTest || false,
          brand === Monitech ? "monitechiid" : brand,
          partnerList,
          enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0
        )
          .catch((error) => console.log("Loading locations failed! " + error))
          .finally(() => setLoading(false));
      } else {
        // 1. Get Lat/Lng from device
        getUserLocation()
          .then((x) => {
            lat = x.coords.latitude;
            lng = x.coords.longitude;

            // 2. Set our Default Center
            setDefaultCenter({ lat: lat, lng: lng });

            // 3. Get locations in the area with lat, lng, deviceType, radius 100
            loadLocationsWithinRadius(
              lat,
              lng,
              300,
              prefillDeviceType,
              enrollNow?.IsTest || false,
              brand === Monitech ? "monitechiid" : brand,
              partnerList,
              enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0
            )
              .catch((error) => {
                console.log("Loading locations failed! " + error);
              })
              .finally(() => {
                // setGetMap(true);
                setLoading(false);
              });
          })
          .catch((x) => {
            // 1.5. Device Geolocation Unavaible get from enrollee obj, or derive from zip code
            console.warn(`ERROR(${x.code}): ${x.message}`);
            if (enrolleeUserData !== undefined && enrolleeUserData !== null) {
              let sCountry = "USA";
              if (siteCountry === Australia) {
                sCountry = "Australia";
              }
              getLocation(enrolleeUserData.zip + "," + sCountry).then((x) => {
                // lat = 0;
                // lng = 0;
                if (x?.results) {
                  lat = x?.results[0]?.geometry?.location?.lat();
                  lng = x?.results[0]?.geometry?.location?.lng();
                }

                // 2. Set our Default Center
                setDefaultCenter({ lat: lat, lng: lng });

                // 3. Get locations in the area with lat, lng, deviceType, radius 100
                loadLocationsWithinRadius(
                  lat,
                  lng,
                  300,
                  prefillDeviceType,
                  enrollNow?.IsTest || false,
                  brand === Monitech ? "monitechiid" : brand,
                  partnerList,
                  enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0
                )
                  .catch((error) => {
                    console.log("Loading locations failed! " + error);
                  })
                  .finally(() => {
                    // setGetMap(true);
                    setLoading(false);
                  });
              });
            } else {
              lat = enrolleeUserData.homeLat;
              lng = enrolleeUserData.homeLong;

              // 2. Set our Default Center
              setDefaultCenter({ lat: lat, lng: lng });

              // 3. Get locations in the area with lat, lng, deviceType, radius 100
              loadLocationsWithinRadius(
                lat,
                lng,
                300,
                prefillDeviceType,
                enrollNow?.IsTest || false,
                brand === Monitech ? "monitechiid" : brand,
                partnerList,
                enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0
              )
                .catch((error) => {
                  console.log("Loading locations failed! " + error);
                })
                .finally(() => {
                  // setGetMap(true);
                  setLoading(false);
                });
            }
          });
      }
    }
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    if (defaultCenter.lat !== 0) {
      setGetMap(true);
      setLoading(true);
    }
  }, [defaultCenter]);
  useEffect(() => {
    const currentState = locations?.[0]?.CurrentState;

    // if (typeof locations !== "undefined" && locations.length > 0) {
    if (currentState !== "Undefined" && currentState !== "None") {
      // Prepare the New Markers
      const newMarkers = locations.map((location) => ({
        key: location.locationID,
        lat: location.latitude,
        lng: location.longitude,
        title: location.displayName,
        label: location?.address1,
        // sameDay: location.sameDay,
        sameDay: prefillDeviceType === "ISA" ? false : location.sameDay,
        partner: location.partner,
      }));

      // Reset result markers on each search/load and keep only Home marker.
      setMarkers((prev) => {
        const homeMarker = prev.find((m) => m.key === "Home");
        return homeMarker ? [homeMarker, ...newMarkers] : newMarkers;
      });
    } else if (currentState === "None") {
      setMarkers((prev) => prev.filter((m) => m.key === "Home"));
    }
    // }
  }, [locations, prefillDeviceType]);

  const transformLanguage = (languageID) => {
    let returnLanguageNames = [];

    if (!languageID) return "";

    let languageIDs = languageID?.split(",").map((id) => id.trim());

    languageIDs.forEach((id) => {
      const displayName = langConversionHelper.getLanguageDisplayName(
        id,
        i18n.language
      );
      if (displayName) returnLanguageNames.push(displayName);
    });

    return returnLanguageNames.join(", ");
  };
  // Search Box Functions
  const handleClear = () => {
    setSearchTerm("");
  };

  const handleSearch = (e) => {
    let lat = 0;
    let lng = 0;
    e?.preventDefault();
    setSearching(true);
    setSelectedLocationId(null);

    let sCountry = "USA";
    if (siteCountry === Australia) {
      sCountry = "Australia";
    }
    let sAddress = searchTerm || " ";
    if (
      sAddress &&
      sAddress.includes("USA") == false &&
      sAddress.includes("Australia") == false
    ) {
      sAddress = sAddress + "," + sCountry;
    }

    getLocation(sAddress)
      .then((x) => {
        if (x !== undefined && x.results !== undefined) {
          lat = x.results[0].geometry.location.lat();
          lng = x.results[0].geometry.location.lng();
          // 2. Set our Default Center
          setDefaultCenter({ lat: lat, lng: lng });
          // 3. Get locations in the area with lat, lng, deviceType, radius 100
          loadLocationsWithinRadius(
            lat,
            lng,
            300,
            prefillDeviceType,
            enrollNow?.IsTest || false,
            brand === Monitech ? "monitechiid" : brand,
            partnerList,
            enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0
          )
            .catch((error) => {
              console.log("Loading locations failed! " + error);
            })
            .finally(() => {
              setSearching(false);
              setLoading(false);
            });
        } else {
          // toast.error(t("outro.searchIssue"));
          setSearching(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setSearching(false);
      });
  };

  const handleLocationSelected = (oLocation) => {
    setSelectedLocationId(oLocation?.locationID || null);
    selectedLocation(oLocation);
  };

  function getLocDisplayName(oLoc) {
    var lName = oLoc.displayName.split("(")[0];
    return lName;
  }

  function DisplayLocations(oLocs) {
    return oLocs.map((oLoc) => (
      <Grid
        size={12}
        style={{ paddingTop: 0, paddingBottom: 0,marginBottom:"2px" }}
        key={oLoc.locationID}
      >
        <Card sx={{ width: "100%" }}>
          <CardActionArea onClick={() => handleLocationSelected(oLoc)}>
            <CardHeader
              brand={brand}
              container
              direction="row"
              alignItems="center"
              // className={classes.cardHeader}
            >
              <Grid size={{ xs: 11 }}>
                {getLocDisplayName(oLoc).length > 32 ? (
                  <Typography style={{ fontSize: 12, fontWeight: "bold" }}>
                    {getLocDisplayName(oLoc)}
                  </Typography>
                ) : (
                  <Typography style={{ fontWeight: "bold" }}>
                    {getLocDisplayName(oLoc)}
                  </Typography>
                )}
              </Grid>
              <Grid size={{ xs: 1 }}>
                <ChevronRightIcon />
              </Grid>
            </CardHeader>
            <CardContent sx={{ p:0,px:2, borderBottom:"6px" }}>
              <Grid container direction="row" alignItems="center">
                <Grid size={{ xs: 6.5 }} sx={{ py:1 }}>
                  <Typography variant="body2" component="p">
                    {oLoc.address1 === "Mobile Location" ||
                    oLoc.address1 === "Mobile" ? (
                      <>
                        <AirportShuttleIcon sx={{ color: "#1c355e" }} />
                        <br />
                        {t("steps.mobileLocation")}
                      </>
                    ) : (
                      <>
                        {oLoc?.address1 +
                          " " +
                          (oLoc?.address2 && oLoc?.address2 != "null"
                            ? oLoc?.address2
                            : "")}
                        <br />
                        {oLoc?.city + ", " + oLoc?.state + " " + oLoc?.zip}
                      </>
                    )}
                    <br />
                    {utilities.formatPhoneNumber(oLoc.phone1)}
                    <br />
                    {transformLanguage(oLoc.languages)}
                  </Typography>
                </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                      height: "auto",
                      alignSelf: "stretch",
                      marginX: "8px",
                      color: "#1C355E",
                    }}
                  />
                <Grid size={{ xs: 4, sm: 3.5 }} sx={{ py:1 }}>
                  {oLoc?.address1 === "Mobile Location" ||
                  oLoc.address1 === "Mobile" ? (
                    <>
                    <Grid sx={{ display:"flex",justifyContent:"center",alignItems:"center" }}>
                      {oLoc?.sameDay === true && prefillDeviceType !== "ISA" ? (
                        <img
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "contain",
                          }}
                          src={sameDayVanIconAltUrl}
                          alt=""
                        />
                      ) : (
                        <img
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "contain",
                          }}
                          src={vanIconAltUrl}
                          alt=""
                        />
                      )}
                      </Grid>
                    </>
                  ) : oLoc?.sameDay === true && prefillDeviceType !== "ISA" ? (
                    <>
                      <Grid sx={{ textAlign: "center" }}>
                        <Grid>
                          <img
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "contain",
                            }}
                            src={sameDayIconAltUrl}
                            alt=""
                          />
                        </Grid>
                          <Grid>
                          {oLoc?.distanceFromHome
                            ? `${oLoc.distanceFromHome.toFixed(1)} ${t(
                                "steps.milesAway"
                              )}`
                            : null}
                        </Grid>
                      </Grid>
                    </>
                  ) : 
                  <>
                    <Grid sx={{ textAlign:"center" }}>
                      {oLoc?.distanceFromHome
                        ? `${oLoc.distanceFromHome.toFixed(1)} ${t(
                            "steps.milesAway"
                          )}`
                        : null}
                    </Grid>
                  </>
                  }
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    ));
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid size={{ lg: 8, xs: 12 }}>
          {getMap === false || loading === true ? (
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RingLoader />
            </Grid>
          ) : (
            <Grid className="ank-google-maps-holder">
              <GoogleMaps
                defaultCenter={defaultCenter}
                locationMarkers={markers}
                locations={locations}
                selectedLocation={handleLocationSelected}
                isLoaded={isLoaded}
                selectedLocationId={selectedLocationId}
              />
              {/* <GoogleMapsLegend /> */}
            </Grid>
          )}
        </Grid>

        <Grid size={{ lg: 4, xs: 12 }}>
          <Grid>
            <Typography>{t("outro.enterTextBox")}</Typography>
          </Grid>
          <Grid>
            <Paper sx={{  textAlign: "left", height: 40 }} >
              <Grid container direction="row">
                <TextField
                  id="txtAddress"
                  size="small"
                  placeholder={t("outro.search")}
                   sx={{
                    "& fieldset": { border: 'none' },
                    flex: 1,
                    "&.MuiInputBase-input":{
                     p: "8px 5px",
                    },
                  }}
                  value={searchTerm || ""}
                  onChange={(event) => {
                    setSearchTerm(event.target.value);
                  }}
                   onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearch();
                    }
                  }}
                  disabled={searching}
                />
                <StyledIconButton
                  type="submit"
                  aria-label="search"
                  onClick={handleSearch}
                  disabled={searching}
                  size="large"
                >
                  <SearchIcon />
                </StyledIconButton>
                <StyledDivider orientation="vertical" />
                <StyledIconButton
                  color="primary"
                  aria-label="clear"
                  onClick={handleClear}
                  disabled={searching}
                  size="large"
                >
                  <ClearIcon />
                </StyledIconButton>
              </Grid>
            </Paper>
          </Grid>
          <Grid sx={{ border:"8px solid #BBBBBB",minHeight:"435px",maxHeight: "435px" }}>
          {getMap === false &&
          searching === false &&
          locations !== undefined &&
          typeof locations !== "undefined" &&
          locations.length === 0 ? (
            <Grid container direction={"column"}>
              <Grid style={{ textAlign: "center",padding:"2px" }}>
                <CustomIcon brand={brand} />
                <CustomTypo>{t("outro.noLocations")}</CustomTypo>
              </Grid>
              <Grid style={{ textAlign: "center" }}>
                <CallButton
                  size="medium"
                  variant="contained"
                  // className={classes.callButton}
                  startIcon={<CallIcon />}
                  href={t(`brandInfo.brandPhoneHref.${brand}`)}
                  foreColor="seconday"
                >
                  {t("error.botCallUsButton") +
                    t(`brandInfo.brandPhone.${brand}`)}
                </CallButton>
              </Grid>
            </Grid>
          ) : searching === true ||
            locations === undefined ||
            typeof locations === "undefined" ||
            locations[0].CurrentState === "Undefined" ? (
            <Grid
              container
              direction="column"
              alignItems="center"
              style={{ marginTop: 50 }}
            >
              <Grid>
                <RingLoader />
              </Grid>
            </Grid>
          ) : locations[0].CurrentState !== "None" ? (
            <Grid size={{ xs: 12 }}>
              <Grid container direction="column">
                {/* <HeaderStyling brand={brand}>
                  {t("outro.searchResults")}
                </HeaderStyling> */}
                <LocationsHolder container direction="row">
                  {DisplayLocations(locations)}
                </LocationsHolder>
              </Grid>
            </Grid>
          ) : (
            <Grid container direction={"column"}>
              <Grid style={{ textAlign: "center",padding:"2px" }}>
                <CustomIcon brand={brand} />
                <CustomTypo>{t("outro.noLocations")}</CustomTypo>
              </Grid>
            </Grid>
          )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

AppointmentLocation.propTypes = {
  locations: PropTypes.array,
  loadLocationsWithinRadius: PropTypes.func,
  selectedLocation: PropTypes.func.isRequired,
  prefillDeviceType: PropTypes.string,
  isLoaded: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    enrollee: state.enrollee,
    locations: state.locations,
  };
}
const mapDispatchToProps = { loadLocationsWithinRadius };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppointmentLocation);
